import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import closeIcon from "resources/img/puffu/close.png";
import clsx from "classnames";
import style from "./HorizontalCartProductCard.module.css";
import { toast } from "react-toastify";
import categorySound from "resources/music/물방울.mp3";
import { useTouchClick } from "shared/hooks/useTouchClick";
import { OutletContext } from "routes/front/main/WebSocketContainer";
import { requester } from "App";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import TrashIcon from "resources/img/icons/TrashIcon";
import { useSelector } from "react-redux";





function HorizontalCartProductCard2(props) {
    const { id } = useParams();
    const { data } = props;
    const [quantity, setQuantity] = useState(1);
    const dispatch = useDispatch();
    const { isMobile } = useContext(BrowserDetectContext);
    const audioRef = useRef();


    const cartRemainProducts = useSelector(state => state.cart.remainProducts);
    const cartRemainProduct = cartRemainProducts ? cartRemainProducts.find(product => product.id === data.id) : null;
    const cartRemainQuantity = cartRemainProduct ? cartRemainProduct.quantity : 0;


    const increaseQuantity = () => {
        const newQuantity = quantity + 1;
        const totalQuantity = newQuantity + cartRemainQuantity;
        if (totalQuantity > data.originQuantity) {
            toast.error("준비한 상품보다 많이 담았어요", {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
            return;
        }
       
        let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
        const cartData = {
            roomId: id,
            code: "updateCartQuantity",
            cartList: [{ 
                id: data.id, 
                productImg: data.productImg, 
                quantity: newQuantity, 
                price: data.price, 
                productName: data.productName, 
                productId: data.productId,
                originQuantity: data.quantity, 
            }],
            deviceCode: deviceCode
        };
        audioRef.current.play();
        setQuantity(newQuantity);
        requester.testOrder(cartData, (result) => {});
        // dispatch(CartReducer.actions.updateQuantity({ id: data.id, quantity: newQuantity }));
    };
        

    const decreaseQuantity = () => {
        if (quantity > 1) {
            audioRef.current.play();
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
            let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
            const cartData = {
                roomId: id,
                code: "updateCartQuantity",
                cartList: [{ id: data.id, productImg: data.productImg, quantity: newQuantity, price: data.price, productName: data.productName, productId: data.productId }],
                deviceCode: deviceCode
            }

            requester.testOrder(cartData, (result) => {
            });
            // dispatch(CartReducer.actions.updateQuantity({ id: data.id, quantity: newQuantity }));
        } else {
            // dispatch(CartReducer.actions.removeProductFromCart({ id: data.id }));
        }
    };

    const onClose = () => {
        audioRef.current.play();
        // dispatch(CartReducer.actions.clearRemainProducts());
        // dispatch(CartReducer.actions.removeProductFromCart({ id: data.id }));
        let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
        const cartData = {
            roomId: id,
            code: "removeProductFromCart",
            cartList: [{ id: data.id }],
            deviceCode: deviceCode
        }

        requester.testOrder(cartData, (result) => {
        });
    };

    useEffect(() => {
        setQuantity(data.quantity);
    }, [data]);

    const { handleTouchStart: decreaseTouchStart, handleTouchEnd: decreaseTouchEnd } = useTouchClick(decreaseQuantity, 10);
    const { handleTouchStart: increaseTouchStart, handleTouchEnd: increaseTouchEnd } = useTouchClick(increaseQuantity, 10);
    return (
        <div className={style.cartProductCard}>
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <div style={{
                width: "100%",
                // padding: "10px 0",
                backgroundColor: "white",
                position: "relative"
            }}>

                <HorizontalFlex gap={10} alignItems={"center"}>
                    <FlexChild width={"20%"} height={"87px"} justifyContent={"center"}>
                        <img src={data.productImg} width={"auto"} height={"100%"} />
                    </FlexChild>
                    <FlexChild width={"30%"}>
                        <Center width={"100%"} textAlign={"left"}>
                            <P weight={500} ellipsis width={"85%"} size={24}>{data.productName}</P>
                            <P size={"1.2vw"} weight={700} font={"Pretendard"} color={"black"}>
                                {data.price && data.price.toLocaleString()}원
                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex >
                            <FlexChild justifyContent={"center"}>
                                <div
                                    className={clsx(
                                        style.button,
                                        style["button--decrease"],
                                        { [style.disabled]: quantity === 1 }
                                    )}
                                    onPointerDown={decreaseTouchStart}
                                    onPointerUp={decreaseTouchEnd}
                                >
                                    <P font={"Pretendard"} weight={700} size={24} color={"white"}>
                                        -
                                    </P>
                                </div>
                            </FlexChild>

                            <FlexChild justifyContent={"center"}>
                                <P weight={"bold"} size={25}>
                                    {quantity && quantity}
                                </P>
                            </FlexChild>

                            <FlexChild justifyContent={"center"}>
                                <div
                                    className={clsx(style.button, style["button--increase"])}
                                    onPointerDown={increaseTouchStart}
                                    onPointerUp={increaseTouchEnd}
                                >
                                    <P font={"Pretendard"} weight={700} size={24} color={"white"}>
                                        +
                                    </P>
                                </div>
                            </FlexChild>
                            <FlexChild justifyContent={"center"}>
                                <div style={{ display: 'flex', justifyContent: 'center' }} onPointerUp={onClose}>
                                    <TrashIcon width={34} height={34} />
                                </div>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                </HorizontalFlex>
            </div>
        </div>
    );
}

export default HorizontalCartProductCard2;